export default (array) => array.reduce((result, acc) => {
  if (result.length === 0) result.push(acc);

  if (result.findIndex((v) => v.duration === acc.duration) === -1) result.push(acc);

  return result;
}, []);
